// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    applicationId: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    applicationId: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(21),
});
export const ApplicationUserConsentOrganizations = Object.freeze({
    table: 'application_user_consent_organizations',
    tableSingular: 'application_user_consent_organization',
    fields: {
        tenantId: 'tenant_id',
        applicationId: 'application_id',
        organizationId: 'organization_id',
        userId: 'user_id',
    },
    fieldKeys: [
        'tenantId',
        'applicationId',
        'organizationId',
        'userId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
